// Libraries
var React = require('react');

// Components
var VoucherCode = require('../VoucherCode/VoucherCode');
var Dialog = require('../Dialog/Dialog');
var DialogButton = require('../Dialog/DialogButton');

var UtilGuid = require('../../common/utilGuid.js');

// Style
require('./MemberWeekVoucher.scss');

class MemberWeekVoucher extends React.Component {
	constructor(props) {

		super(props);

	}

	render() {
        const dialogName = 'dialog-' + UtilGuid.guid();
        const dialogAdditionalClass = 'c-dialog--qr-code c-dialog--close-button-outside' + (this.props.data.isOneHotspur ? ' c-dialog--one-hotspur' : '');
		return (
			<div className={`c-section c-section--always-padded c-section--member-week-voucher${this.props.data.isOneHotspur ? " c-section--one-hotspur c-section--one-hotspur-highlight" : ""}`} id={this.props.data.id} data-user-id={this.props.data.userId}>
                <div className="c-section__inner">
					<div className="c-section__inner__inner">
                        <div className={`c-member-week-voucher${this.props.data.isOneHotspur ? " c-member-week-voucher--one-hotspur" : ""}`}>
                            <div className="c-member-week-voucher__inner">
                                {this.props.data.title &&
                                    <h2 className="c-member-week-voucher__title">{this.props.data.title}</h2>
                                }
                                {this.props.data.description &&
                                    <p className="c-member-week-voucher__description">{this.props.data.description}</p>
                                }
                                <div className="c-member-week-voucher__content">
                                    <div className="c-member-week-voucher__content__inner">
                                        <p className="c-member-week-voucher__content__text">Your unique code:</p>
                                        <p className="c-member-week-voucher__content__code">
                                            <VoucherCode code={this.props.data.code} redeemCtaText="Reedem now" redeemed={false} alternateStyle="true" />
                                        </p>
                                        {this.props.data.hasQrCode &&
                                            <p className="c-member-week-voucher__content__text">Or</p>
                                        }
                                        {this.props.data.hasQrCode &&
                                            <div className={`c-member-week-voucher__content__qr`}>
                                                <DialogButton name={dialogName} additionalClass="c-button c-button--dark">View your QR code</DialogButton>
                                                <Dialog name={dialogName} additionalClass={dialogAdditionalClass}>
                                                    <div className="c-dialog--qr-code__content">
                                                        <div className="c-dialog--qr-code__code">
                                                            <div className="c-dialog--qr-code__code-image">
                                                                <div className="c-dialog--qr-code__code-image-inner">
                                                                    {this.props.data.qrCodeUrl && <img src={this.props.data.qrCodeUrl} alt="" />}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="c-dialog--qr-code__text">
                                                            <p className="c-dialog--qr-code__text-title">{this.props.data.title}</p>
                                                            <p className="c-dialog--qr-code__text-subtitle">Here's your unique QR code!</p>
                                                        </div>
                                                    </div>
                                                </Dialog>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
			</div>
		);
	}
};

module.exports = MemberWeekVoucher;


// WEBPACK FOOTER //
// ./src/components/MemberWeekVoucher/MemberWeekVoucher.js